import VueJwtDecode from 'vue-jwt-decode'

export default {
  methods: {
    /**
     * Método generico para recuperar el id interno del sistema (LTI) del usuario logado del JWT
     */
    jwtLoggedUserId () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.user
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar el id en el LMS del usuario logado del JWT
     */
    jwtLoggedUserLmsId () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.userLms
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar el id interno del sistema (LTI) del usuario logado del JWT
     */
    jwtConsumerId () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.consumer
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar el sistema que esta ejecutando el LTI
     */
    jwtConsumerCode () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.consumercode
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar el color principal asociado a la licencia LTI
     */
    jwtPrimaryColor () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.primaryColor
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar el color secundario asociado a la licencia LTI
     */
    jwtSecondaryColor () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.secondaryColor
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar la fuente de texto asociado a la licencia LTI
     */
    jwtFont () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.font
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar el id interno del sistema (LTI) del site desde el que se accede del JWT
     */
    jwtContextSite () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.context
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar la lista los roles del usuario logado del JWT
     */
    jwtLoggedUserRoles () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.roles
        } catch (e) {
          return []
        }
      }
      return []
    },
    /**
     * Método generico para calcula el rol del usuario en el sistema de clases destino según su rol en la aplicación
     */
    jwtLoggedUserTargetSystemRole (targetSystem) {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          let roles = jwtDecoded.roles
          if (targetSystem === 'COLLAB') {
            if (roles.includes('ROLE_PRESENTER')) {
              return 'MODERATOR'
            }
            return 'PARTICIPANT'
          } else if (targetSystem === 'CONNECT') {
            if (roles.includes('ROLE_PRESENTER')) {
              return 'MODERATOR'
            }
            return 'PARTICIPANT'
          } else if (targetSystem === 'ZOOM') {
            if (roles.includes('ROLE_PRESENTER')) {
              return 'MODERATOR'
            }
            return 'PARTICIPANT'
          }
        } catch (e) {
          return null
        }
      }
      return null
    },
    /**
     * Método generico para recuperar la instancia de connect asociada a la licencia para la creación manual de sesiones
     */
    jwtDefaultAcInstance () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.consumerAcInstance
        } catch (e) {
          return []
        }
      }
      return []
    },
    /**
     * Método generico para recuperar la instancia de Zoom asociada a la licencia para la creación manual de sesiones
     */
    jwtDefaultZoomInstance () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          console.log(jwtDecoded.consumerZoomInstance)
          return jwtDecoded.consumerZoomInstance
        } catch (e) {
          console.log(e)
          return []
        }
      }
      return []
    },
    /**
     * Método generico para recuperar el idioma en la plataforma
     */
    jwtLanguage () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.language
        } catch (e) {
          return 'es'
        }
      }
      return 'es'
    },
    /**
     * Método para recuperar los perfiles habilitados en el backend
     */
    jwtProfiles () {
      const token = this.$cookies.get('LTI_JWT')

      if (token) {
        try {
          let jwtDecoded = VueJwtDecode.decode(token)
          return jwtDecoded.profiles
        } catch (e) {
          return null
        }
      }
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/jwtMixin.js